import {combineReducers} from 'redux';
// import {persistStore, persistReducer} from 'redux-persist';
import HomeReducer from './reducers/HomeReducer';
import listingReducer from './reducers/listingReducer';
import detailReducer from './reducers/detailReducer';
import cartReducer from './reducers/cartReducer';
import checkoutReducer from './reducers/checkoutReducer';
import thankyouReducer from './reducers/thankyouReducer';
import contactReducer from './reducers/contactReducer';
import dataProtectionReducer from './reducers/dataProtectionReducer';
import TermsConditionsReducer from './reducers/TermsConditionsReducer';
import GalleryCollectionReducer from './reducers/GalleryCollectionReducer';
import OurLabsReducer from './reducers/OurLabsReducer';
import FramesReducer from './reducers/FramesReducer';
import QualityPrintsReducer from './reducers/QualityPrintsReducer';
import AuthReducer from './reducers/AuthReducer';
import OrderDetailReducer from './reducers/OrderDetailReducer';
 import WishlistReducer from './reducers/wishlistReducer';
 import CreditSlipReducer from './reducers/CreditSlipReducer';
import languageReducer from './reducers/LanguagesReducer';
import recentlyViewedSlice from './reducers/recentlyViewedSlice';

const persistConfig = {
    key: 'root',
    // storage: AsyncStorage,
    // whitelist: ['user'],
  };
  const rootReducer = combineReducers({
    // user :   UserReducer,
    home :  HomeReducer,
    shop :  listingReducer,
    product_detail :  detailReducer,
    recentlyViewedProducts: recentlyViewedSlice,
    // storelist: StorelistReducer,
    checkoutpage:checkoutReducer,
    cartpage:cartReducer,
    thankyoupage:thankyouReducer,
    contactpage:contactReducer,
    dataprotectionpage:dataProtectionReducer,
    termsconditionspage:TermsConditionsReducer,
    gallerycollectionpage:GalleryCollectionReducer,
    ourlabspage:OurLabsReducer,
    framespage:FramesReducer,
    qualityprintspage:QualityPrintsReducer,
    auth:AuthReducer,
    orderdetail:OrderDetailReducer,
        wishlistpage:WishlistReducer,
        creditslip:CreditSlipReducer,
    languages:languageReducer
    // order:OrderReducer,
    // category:CategoryReducer,
    // brand:BrandReducer,
    // offer:OfferReducer,
    // legal:legalReducer,
    // review:ReviewReducer,
    // currency:CurrencyReducer
  })
 
export default rootReducer;